import axiosClient from "./axiosClient";

export const listarGastosEsporadicos = (cuentaId, pagina = 1) =>
  axiosClient.get(`/gastos-esporadicos/cuenta/${cuentaId}`, { params: { pagina } }).then((r) => r.data);
export const listarGastosEsporadicosRecientes = (cuentaId, mes, anio) =>
  axiosClient.get(`/gastos-esporadicos/cuenta/${cuentaId}/recientes`, { params: { mes, anio } }).then((r) => r.data);
export const listarHistoricoGastosEsporadicos = (cuentaId, desde, hasta, pagina = 1) =>
  axiosClient.get("/gastos-esporadicos/historico", { params: { cuentaId, desde, hasta, pagina } }).then((r) => r.data);
export const registrarGastoEsporadico = (data) => axiosClient.post("/gastos-esporadicos", data).then((r) => r.data);
export const eliminarGastoEsporadico = (id) => axiosClient.delete(`/gastos-esporadicos/${id}`);
